export const endpoints = {
  blog: {
    createBlog: "create-blog",
    blogsList: "blogs",
    blogsDetails: "blog",
    updateStatus: "change-blog-status",
    updateBlog: "update-blog",
  },
  infographic: {
    createInfographic: "add_infographic",
    infographicsList: "infographics",
    infographicsDetails: "infographic",
    updateStatus: "change-infographic-status",
    updateInfographic: "update-infographic",
  },
  glossary: {
    createGlossary: "create-glossary-post",
    getLettersAndType: "get-unique-data",
    glossaryList: "get-glossary-by-status-type",
    glossaryDetails: "get-glossary",
    updateStatus: "change-glossary-status",
    updateGlossary: "update-glossary",
  },
  industry: {
    industryList: "industries",
    industryNameList: "industry-list",
    changeIndustryStatus: "change-industry-status",
    getIndustryById: "industry",
  },
  tos:{
    create:'create-tos',
    list:'tos-list',
    updateStatus:'update-tos-post-status',
    details:'tos'
  },
  polling:'check-db-connection'
};
